import React, { useCallback, useEffect, useState } from 'react';
import '../css/global.css';
import err from '../img/empty.svg'
import {Button} from '@mui/material';
import '../css/components.css'



export default function Empty(props) {
    // eslint-disable-next-line
    const [message, setMessage] = useState(false);

    const getMessage = useCallback(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.has('message')) {
            setMessage(urlParams.get('message'));
        } else {
            setMessage(false);
        }
    }, []);

    useEffect(() => {
        getMessage();
    }, [getMessage]);

    return (
        
            <div className="container-empty" >
               <div className="error-template">
                <img src={err} alt="err" id='err'/>
                <div className="error-content">
                    <p className='Title-err'>
                        { "Nous sommes dèsolès, la page que vous cherchez est introuvable."}
                    </p> 
                </div>
                <Button variant="contained" className='Btn-acceuil-err'  onClick={()=>window.location=('/')} >Retour à l'accueil </Button>          

                </div> 
            </div>
        
    );
}

